







































import { Vue, Component, Model, Prop, Watch } from "vue-property-decorator";
import AdUnit, { AdUnitFilter } from "@/models/adUnit";
import AdUnitsAPI from "@/services/adUnits";
import { QueryParams } from "@/models/general";
import { isArray } from "lodash";
import { loadingSceneName } from "@aws-amplify/ui";

@Component
export default class AdUnitsSelector extends Vue {
  @Model("change") value?: string[] | string;
  @Prop({ default: "campaigns.model.ad_units" }) label!: boolean;
  @Prop({ default: () => [] }) rules!: boolean[];
  @Prop({ default: true }) multiple!: boolean;
  @Prop({ default: false }) dense!: boolean;
  @Prop({ default: null }) filter!: AdUnitFilter;
  @Prop({ default: false }) allButton!: boolean;
  @Prop({ default: false }) singleLine!: boolean;

  adUnits: AdUnit[] = [];
  loading = false;
  allSelected = false;

  created(): void {
    this.getAdUnits();
  }

  async getAdUnits(): Promise<void> {
    try {
      this.loading = true;
      const params: QueryParams = this.filter;

      const r = await AdUnitsAPI.list(params);
      this.adUnits = r.data.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });

      this.value !== "" && this.value ? this.onChange(this.value) : null;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  // @Watch("value", { deep: true })
  onChange(id: string | string[]): void {
    const adUnit = isArray(id)
      ? this.adUnits.filter((adUnit: AdUnit) =>
          id.find((e: string) => adUnit.id === e)
        )
      : this.adUnits.find((e: AdUnit) => e.id === id);

    this.$emit("onSelect", adUnit);
    this.$emit("change", id);
  }

  @Watch("filter", { deep: true })
  changeFilter(): void {
    this.getAdUnits();
  }

  toggleAll(): void {
    this.allSelected = !this.allSelected;

    const adUnitsIds = this.allSelected ? this.adUnits.map((a) => a.id) : [];

    adUnitsIds ? this.onChange(adUnitsIds as string[]) : [];
  }
}
